export const SET_RESET_PASSWORD_STATUS = 'login/SET_RESET_PASSWORD_STATUS';
export const START_RESET_PASSWORD = 'login/START_RESET_PASSWORD';
